import type { ReactNode } from 'react';

export type BadgeTone = 'neutral' | 'accent' | 'navy' | 'verified' | 'gap' | 'danger';

const TONE: Record<BadgeTone, string> = {
  neutral: 'bg-surface-sunken text-ink-soft border-line',
  accent: 'bg-accent-soft text-accent-strong border-accent/20',
  navy: 'bg-navy-soft text-navy border-navy/20',
  verified: 'bg-verified-soft text-verified border-verified/25',
  gap: 'bg-gap-soft text-gap border-gap/25',
  danger: 'bg-danger-soft text-danger border-danger/25',
};

interface BadgeProps {
  tone?: BadgeTone;
  children: ReactNode;
  /** Optional leading dot for a compact status cue. */
  dot?: boolean;
  className?: string;
}

/**
 * Pill-shaped status / provenance label. Text carries the meaning so colour is
 * never the only signal.
 */
export function Badge({ tone = 'neutral', dot = false, className = '', children }: BadgeProps) {
  return (
    <span
      className={[
        'inline-flex items-center gap-1.5 rounded-pill border px-2.5 py-0.5 text-xs font-semibold',
        TONE[tone],
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {dot ? (
        <span
          aria-hidden="true"
          className="h-1.5 w-1.5 rounded-full bg-current opacity-80"
        />
      ) : null}
      {children}
    </span>
  );
}
